// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3l_RA","type":"styles_type__2l5iF","choices":"styles_choices__f81M-"};